export default __webpack_public_path__ + "static/media/transkey.da4a3f97.svg";